
import React from 'react';
import { Check } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  promptMode?: boolean;
}

export const StepIndicator = ({ 
  currentStep, 
  totalSteps,
  promptMode = false
}: StepIndicatorProps) => {
  if (promptMode) {
    // In prompt mode show a single indicator or none at all
    return (
      <div className="w-full flex justify-center my-8">
        <div className="relative w-full max-w-md">
          <div className="h-3 rounded-full bg-gradient-to-r from-border via-border to-border overflow-hidden">
            <div 
              className={`h-full rounded-full bg-gradient-to-r from-primary to-secondary transition-all duration-1000 ${
                currentStep === 4 ? 'w-full' : 'w-0'
              }`}
            />
          </div>
          <div className="text-center mt-3">
            <span className="text-sm text-text-secondary font-medium">
              {currentStep === 4 ? 'Analysis Complete!' : 'Analyzing your situation...'}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center my-8">
      <div className="flex items-center justify-between w-full max-w-md">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center">
                <div 
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300
                    ${isCompleted 
                      ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg' 
                      : isCurrent 
                        ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg animate-pulse'
                        : 'bg-border text-text-secondary'
                    }
                  `}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    stepNumber
                  )}
                </div>
                <div 
                  className={`
                    w-2 h-2 rounded-full mt-2 transition-all duration-300
                    ${isCurrent ? 'bg-primary animate-pulse' : 'bg-transparent'}
                  `}
                />
              </div>
              
              {index < totalSteps - 1 && (
                <div 
                  className={`
                    flex-1 h-0.5 mx-2 transition-all duration-500
                    ${isCompleted 
                      ? 'bg-gradient-to-r from-primary to-secondary' 
                      : 'bg-border'
                    }
                  `}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
